// extracted by mini-css-extract-plugin
module.exports = {"tag_wrapper":"tag_wrapper___-j3G3","orange":"orange___16pfU","green":"green___1Pdfs","grey":"grey___1_bfG"};